<template lang="pug">
	.production-tool-contracting-feedback.success
		VueFeedback(type="success")
			template(slot="feedback-title") Köszönjük érdeklődését!
			template(slot="feedback-content") Kollégánk rövidesen keresni fogja az ajánlattal kapcsolatban.
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	}
};
</script>

<style src="@ui-common/vue-feedback/dist/vue-feedback.css"></style>
